import { useContext, createContext, ReactNode, useState } from 'react';
import { IRepresentativesProfile } from 'shared/interfaces/IRepresentatives';
import { representativeService } from 'shared/services/representativesService';
import RepresentativeErrorUI from '../components/RepresentativeErrorUI/RepresentativeErrorUI';

type RepresentativesContextProps = {
  profiles?: IRepresentativesProfile[];
  isLoading: boolean;
  isFetching: boolean;
};

const { getRepresentativesProfile } = representativeService();

export const RepresentativesContext = createContext<RepresentativesContextProps>({
  profiles: undefined,
  isLoading: false,
  isFetching: false,
});

export const RepresentativesProvider = ({ children }: { children: ReactNode }) => {
  // Getting the Profiles
  const { data, isLoading, isError, isFetching, refetch } = getRepresentativesProfile();

  // If theres an error, render this UI
  if (isError) return <RepresentativeErrorUI onButtonClick={() => refetch()} />;

  return (
    <RepresentativesContext.Provider value={{ profiles: data?.data?.profiles, isLoading, isFetching }}>
      {children}
    </RepresentativesContext.Provider>
  );
};

export const useRepresentativesContext = () => {
  const context = useContext(RepresentativesContext);

  if (context === undefined) {
    throw new Error('You need context for this component');
  }

  return context;
};
